<b3-drawer
  [open]="isOpen"
  size="sm"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Filtrar"
    show-back
    back-aria-label="Fechar filtros">
  </b3-drawer-header>

  <b3-drawer-body>
    <form class="filter-form" [formGroup]="formFilter">
      <div class="filter-field">
        <b3-input-text
          formControlName="holderAccount"
          inputId="holderAccount"
          label="Conta do Detentor"
          background="grey"
          mask="account"
          placeholder="00000.00-0">
        </b3-input-text>
      </div>

      <div class="filter-field">
        <b3-input-text
          formControlName="carbonCreditCode"
          inputId="carbonCreditCode"
          label="Código de Inst. Financeiro"
          background="grey"
          mask="instrument"
          placeholder="Pesquisar pelo código do instrumento financeiro">
        </b3-input-text>
      </div>

      <div class="filter-section">
        <p class="filter-section__title">Data da Operação</p>
        <ng-container *ngFor="let resetKey of [datepickerResetKey]; trackBy: trackDatepickerResetKey">
          <div class="filter-section__row">
            <div class="filter-field">
              <b3-datepicker
                inputId="initialDate"
                label="Data Inicial"
                formControlName="initialDate"
                background="grey"
                placeholder="DD/MM/AAAA"
                locale="pt-BR"
                [max]="maxInitialDateIso"
                [error]="invalidPeriodDate"
                (b3-change)="onInitialDateChange($event)">
              </b3-datepicker>
            </div>
            <div class="filter-field">
              <b3-datepicker
                inputId="finalDate"
                label="Data Final"
                formControlName="finalDate"
                background="grey"
                placeholder="DD/MM/AAAA"
                locale="pt-BR"
                popoverLeftOffset="-110px"
                [min]="minFinalDateIso"
                [error]="invalidPeriodDate"
                (b3-change)="onFinalDateChange($event)">
              </b3-datepicker>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="filter-actions">
        <b3-button
          type="button"
          variant="ghost"
          tone="default"
          size="lg"
          class="filter-actions__btn"
          (b3-click)="cleanForm()">
          <b3-icon name="backspace" size="sm"></b3-icon>
          Limpar
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          size="lg"
          class="filter-actions__btn"
          [disabled]="invalidPeriodDate"
          (b3-click)="filter()">
          <b3-icon name="filter_list" size="sm" tone="on-brand"></b3-icon>
          Filtrar
        </b3-button>
      </div>
    </form>
  </b3-drawer-body>
</b3-drawer>
